import { Button, Column, Row, Text } from "@gradience/ui";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: () => (
    <Column
      style={{
        minHeight: "100dvh",
        alignItems: "center",
        justifyContent: "center",
        gap: 84,
        textAlign: "center",
        paddingBottom: 58,
        boxSizing: "border-box",
      }}
    >
      <Column
        style={{
          alignItems: "center",
          justifyContent: "center",
          gap: 84,
          textAlign: "center",
          flex: 1,
        }}
      >
        <img style={{ maxWidth: 188 }} src="/exam-logo.png" alt="logo" />
        <Column
          style={{
            gap: 32,
            alignItems: "center",
            justifyContent: "center",
            maxWidth: 790,
          }}
        >
          <Text
            textStyle="32px - Bold"
            style={{
              fontFamily: "Abhaya Libre",
              fontSize: "5em",
              lineHeight: "1.2em",
              fontWeight: "medium",
            }}
          >
            Welcome to the Universal Latin Exam{" "}
          </Text>
          <Text
            textStyle="20px - Bold"
            style={{ fontWeight: "medium", maxWidth: 428 }}
          >
            Earn awards for your school and gain insights into how your
            curriculum is performing.
          </Text>
          <Row gap={16}>
            <Button
              text="Sign Up"
              to="/sign-up"
              size="medium"
              variant="primary"
            />
            <Button text="Log In" to="/log-in" size="medium" />
          </Row>
        </Column>
      </Column>
      <a
        href="https://gradience.co"
        target="_blank"
        rel="noreferrer"
        style={{ textDecoration: "none" }}
      >
        <Column gap={10} style={{ alignItems: "center" }}>
          <Text textStyle="12px - Bold" style={{ fontWeight: 500 }}>
            The ULE is powered by
          </Text>
          <img
            style={{ maxWidth: 94 }}
            src="/gradience.svg"
            alt="gradience-logo"
          />
        </Column>
      </a>
    </Column>
  ),
});
